import marketing from './marketing'
import countries from './countries'
import intelligence from './intelligence'

export default {
  marketing,
  countries,
  intelligence
}
